import { connect } from 'react-redux'
import { setParentFormField, setParentForm } from 'actions/account/parents'
import { setErrorMessage } from 'actions/account'

const mapStateToProps = ({ parents: { form } }) => ({ form })

const actions = { setParentFormField, setParentForm, setErrorMessage }

const withRedux = connect(mapStateToProps, actions)

export default withRedux
